<button
  class="notification-button"
  mat-mini-fab
  [matMenuTriggerFor]="bell"
  [matTooltip]="'Notification-Title' | translate: {Default: 'Notifications'}"
  [attr.aria-label]="'Notification-Title' | translate: {Default: 'Notifications'}">
  <mat-icon class="material-icons-outlined notification-button__icon">notifications</mat-icon>
  <span *ngIf="store.unreadCount() > 0" class="notification-button__badge" [style.background]="accent">{{ badgeText }}</span>
</button>

<mat-menu #bell="matMenu" xPosition="before" class="notification-menu">
  <div class="notification-menu__header" (click)="$event.stopPropagation()">
    <span class="notification-menu__title">{{ 'Notification-Title' | translate: {Default: 'Notifications'} }}</span>
    <button
      *ngIf="store.unreadCount() > 0"
      mat-button
      class="notification-menu__link"
      [style.color]="accent"
      (click)="markAllRead($event)">
      <mat-icon class="material-icons-outlined">done_all</mat-icon>
      {{ 'Notification-MarkAllRead' | translate: {Default: 'Mark all as read'} }}
    </button>
  </div>

  <div class="notification-menu__list">
    <div
      *ngFor="let n of store.notifications(); trackBy: trackById"
      class="notification-item"
      [class.notification-item--unread]="!n.read"
      role="menuitem"
      tabindex="0"
      (click)="open(n)"
      (keydown.enter)="open(n)">
      <div class="notification-item__icon" [ngClass]="'notification-item__icon--' + n.status">
        <mat-icon class="material-icons-outlined">{{ n.icon }}</mat-icon>
      </div>

      <div class="notification-item__body">
        <div class="notification-item__title">{{ n.titleKey | translate: {Default: n.titleDefault} }}</div>
        <div *ngIf="n.message" class="notification-item__message" [title]="n.message">{{ n.message }}</div>
        <div class="notification-item__time">
          <span *ngIf="n.status === 'info'" class="notification-item__progress">
            <mat-spinner diameter="10" strokeWidth="2"></mat-spinner>
            {{ 'Notification-InProgress' | translate: {Default: 'In progress'} }} ·
          </span>
          {{ timeAgo(n) }}
        </div>
      </div>

      <span *ngIf="!n.read" class="notification-item__dot" [style.background]="accent"></span>
      <button
        class="notification-item__remove"
        (click)="remove($event, n)"
        [attr.aria-label]="'Notification-Remove' | translate: {Default: 'Remove'}">
        <mat-icon class="material-icons-outlined">close</mat-icon>
      </button>
    </div>

    <div *ngIf="store.notifications().length === 0" class="notification-menu__empty" (click)="$event.stopPropagation()">
      <mat-icon class="material-icons-outlined">notifications_none</mat-icon>
      <span>{{ 'Notification-Empty' | translate: {Default: "You're all caught up"} }}</span>
    </div>
  </div>

  <div
    *ngIf="hub.state() === 'disconnected' || store.notifications().length"
    class="notification-menu__footer"
    (click)="$event.stopPropagation()">
    <span *ngIf="hub.state() === 'disconnected'" class="notification-menu__offline">
      <mat-icon class="material-icons-outlined">cloud_off</mat-icon>
      {{ 'Notification-Offline' | translate: {Default: 'Live updates paused'} }} ·
      <a class="notification-menu__retry" [style.color]="accent" (click)="retry($event)">
        {{ 'Notification-Retry' | translate: {Default: 'Retry'} }}
      </a>
    </span>
    <button
      *ngIf="store.notifications().length"
      mat-button
      class="notification-menu__link notification-menu__link--muted"
      (click)="clearAll($event)">
      {{ 'Notification-ClearAll' | translate: {Default: 'Clear all'} }}
    </button>
  </div>
</mat-menu>
